import React from 'react'

function TermsItem({subheading, content}) {
  return (
    <div>
        <h3>{subheading}</h3>
        {content.map && content.map((item, index) => <p key={index}>{item}</p>)}
        
    </div>
  )
}

export default TermsItem